'use client';

import { Box, Container } from '@chakra-ui/react';
import BannerList from './components/BannerList';
import BannerListSkeleton from './components/BannerListSkeleton';
import QueryBoundary from '@/components/ui/QueryBoundary';

export const MainBannerSection = () => {
  return (
    <Box as="section" width="100%" backgroundColor="common.100">
      <Container
        position="relative"
        width="100%"
        overflow="hidden"
        padding={0}
        maxWidth="1280px"
        margin="0 auto"
        backgroundColor="common.100"
      >
        <Box
          position="relative"
          width="100%"
          height={{ base: 'calc(100vw)', tablet: '600px' }}
          margin="0 auto"
          backgroundColor="neutral.400"
          padding={0}
          overflow="hidden"
        >
          <QueryBoundary loadingFallback={<BannerListSkeleton />}>
            <BannerList />
          </QueryBoundary>
        </Box>
      </Container>
    </Box>
  );
};

export default MainBannerSection;
